import IBuyFeatureConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/IBuyFeatureGameConfig';
import ISymbolTypeGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/ISymbolTypeGameConfig';
import AbstractVendorGameGeneralConfig from '../../vendor_core/src/vendorConfigs/AbstractVendorGameGeneralConfig';
import GameModel from '../../vendor_core/core/src/model/GameModel';
import IAdvanceGeneralGameConfig from '../../vendor_core/core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig';
import IVendorClientConfigRequestData from '../../vendor_core/src/server/requests/contracts/IVendorClientConfigRequestData';
import IFantasmaConfig from '../../vendor_core/src/server/data/IFantasmaConfig';


class GameGeneralConfig extends AbstractVendorGameGeneralConfig implements IFantasmaConfig {
    symbolType: ISymbolTypeGameConfig = {
        spine: true,
        standard: false,
        symbol3D: false
    };

    minWatchTime = 1;
    minWinAnimTime = 0.5;
    maxWinCapMultiplier?: number = 10000;
}

export default new GameGeneralConfig()
